import type { Group } from '@api/instant_survey/utilities/types';

import { Checkbox, HelpIcon, OverlayTriggerTooltip } from '@utilities';

import ConceptPreview from '../../../ConceptPreview';

import styles from './_index.module.scss';

export const DYNAMIC_CONCEPT_IMAGE_HELP_TEXT =
  'Shows each respondent the concept image tied to their panelist group.';

export const DYNAMIC_CONCEPT_IMAGE_LABEL = 'Show Dynamic Concept Image';

interface DynamicConceptImageControlProps {
  groups?: Group[];
  isDisabled: boolean;
  isSelected: boolean;
  onChange: () => void;
}

const DynamicConceptImageControl = ({
  groups,
  isDisabled,
  isSelected,
  onChange,
}: DynamicConceptImageControlProps) => {
  return (
    <div className={styles['dynamic-concept-image-control']}>
      <Checkbox
        aria-label={DYNAMIC_CONCEPT_IMAGE_LABEL}
        isChecked={isSelected}
        isDisabled={isDisabled}
        label={
          <div className={styles['dynamic-concept-image-label']}>
            <strong>{DYNAMIC_CONCEPT_IMAGE_LABEL}</strong>
            <OverlayTriggerTooltip content={DYNAMIC_CONCEPT_IMAGE_HELP_TEXT}>
              <span
                aria-label={DYNAMIC_CONCEPT_IMAGE_HELP_TEXT}
                className={styles['dynamic-concept-image-help']}
                data-testid="dynamic-concept-image-help"
                role="img"
                tabIndex={-1}
              >
                <HelpIcon />
              </span>
            </OverlayTriggerTooltip>
          </div>
        }
        onChange={onChange}
        value={isSelected}
      />
      {isSelected && <ConceptPreview groups={groups} />}
    </div>
  );
};

export default DynamicConceptImageControl;
